import firebase from "firebase/app";
import "firebase/auth"
import "firebase/firestore"
import "firebase/storage"

// firebase init - add your own config here
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//     apiKey: "AIzaSyBNoae4li0GqeS9LauUWAh6MT3RlzD-e-o",
//     authDomain: "aavinfedrecruitment-a425e.firebaseapp.com",
//     databaseURL: "https://aavinfedrecruitment-a425e.firebaseio.com",
//     projectId: "aavinfedrecruitment-a425e",
//     storageBucket: "aavinfedrecruitment-a425e.appspot.com",
//     messagingSenderId: "721571536021",
//     appId: "1:721571536021:web:5212127800af4c3b7ccf9c",
//     measurementId: "G-0JKNHMFXX7"
// };
// const firebaseConfig = {
//     apiKey: "AIzaSyBAR6MvJShVwIY-2v-3gtu3DFwLEK-wWRE",
//     authDomain: "theniaavinrecruitment.firebaseapp.com",
//     databaseURL: "https://theniaavinrecruitment.firebaseio.com",
//     projectId: "theniaavinrecruitment",
//     storageBucket: "theniaavinrecruitment.appspot.com",
//     messagingSenderId: "964593740399",
//     appId: "1:964593740399:web:f631a72244fa28532cfb9a",
//     measurementId: "G-Q46Y05S4SF"
// };

const firebaseConfig = {
    apiKey: "AIzaSyCBUBJTbiilc4X5NITHXCvSg-XrCT9SSAQ",
    authDomain: "aavinfedrecruitment-2.firebaseapp.com",
    databaseURL: "https://aavinfedrecruitment-2.firebaseio.com",
    projectId: "aavinfedrecruitment-2",
    storageBucket: "aavinfedrecruitment-2.appspot.com",
    messagingSenderId: "174583957230",
    appId: "1:174583957230:web:5d5cf22b0f23ca405695ff",
    measurementId: "G-JE4C9EV966"
};
firebase.initializeApp(firebaseConfig)

// utils
const db = firebase.firestore()
const auth = firebase.auth()
const storage = firebase.storage()

// collection references
const usersCollection = db.collection('users')
const applicationsCollection = db.collection('applications')
const departmentsCollection = db.collection('departments')
const time = firebase.firestore.FieldValue;

// export utils/refs
export {
    db,
    auth,
    storage,
    usersCollection,
    applicationsCollection,
    departmentsCollection,
    time
}